import React, { useCallback, useContext } from "react"
import TooltipTrigger from "../TooltipTrigger/TooltipTrigger"
import { WithT } from "i18next"
import { ROOT_CATEGORY_CODE } from "../../utility/knowledgeBase/knowledgeBase"
import { faChevronLeft } from "@fortawesome/pro-light-svg-icons/faChevronLeft"
import IconButton from "../IconButton/IconButton"
import { TreeItem } from "@atlaskit/tree/types"
import styles from "./CurrentBranch.module.scss"
import { buildArticleActionUrl, normalizeArticleSharedUrl } from "../../utility/knowledgeBase/articleUrlHelper"
import { ArticleAction } from "../../models/article"
import KnowledgeBaseContext from "../KnowledgeBaseProvider/KnowledgeBaseContext"
import { testId } from "../../utility/tests/testId/knowledgeBase"

const tNamespace = "knowledgeBase:"

interface Props {
    parentCategory: TreeItem
    onParentClick: (parentCategory: TreeItem) => void
}

const CurrentBranch: React.FC<Props & WithT> = props => {
    const { parentCategory, onParentClick, t } = props

    const {
        data: { title: parentTitle, symbolCode }
    } = parentCategory

    const { url } = useContext(KnowledgeBaseContext)

    const handleParentClick = useCallback(
        (event?: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
            if ((event?.ctrlKey || event?.metaKey || event?.shiftKey) && symbolCode !== ROOT_CATEGORY_CODE) {
                return
            }
            event?.preventDefault()
            onParentClick(parentCategory)
        },
        [onParentClick, parentCategory]
    )

    const title = parentTitle ? parentTitle : t(`${tNamespace}untitled`)

    const BranchTitle = (
        <TooltipTrigger id="current-branch" placement="bottom" content={title}>
            <IconButton
                className={styles.currentBranch}
                iconClassName={styles.currentBranch__parentIcon}
                variant="link"
                icon={faChevronLeft}
                iconSize="xs"
                hideIcon={symbolCode === ROOT_CATEGORY_CODE}
                testId={testId.currentBranchParentIcon}
                onClick={handleParentClick}
            >
                <div className={styles.currentBranch__parentTitle}>{title}</div>
            </IconButton>
        </TooltipTrigger>
    )

    if (symbolCode === ROOT_CATEGORY_CODE) {
        return BranchTitle
    }

    return (
        <a
            data-testid={testId.currentBranchParentLink}
            href={normalizeArticleSharedUrl(buildArticleActionUrl(url, ArticleAction.View, symbolCode))}
            rel="noopener noreferrer"
            onClick={event => handleParentClick(event)}
            className={styles.parentLink}
        >
            {BranchTitle}
        </a>
    )
}

export default CurrentBranch
